import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base.service';
import { Concepto } from 'src/app/models/tesoreria/concepto.model';
import { GrupoAccesoRegistro } from 'src/app/models/seguridad/grupo_acceso.model';

@Injectable({
  providedIn: 'root'
})
export class ConceptoService extends BaseService {

    recordName = 'conceptos';

    codigoModulo = Concepto.CODIGO_MODULO;
    codigoRegistro = Concepto.CODIGO_REGISTRO;

    url = `${ environment.host }/concepto`;

}
